var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"align-center"},[_c('v-col',{staticClass:"text-center"},[_c('h3',[_vm._v(_vm._s(_vm.title))])])],1),_c('v-row',[_c('v-col',{staticStyle:{"height":"400px"},attrs:{"cols":"12"}},[_c('BarChart',{attrs:{"data":_vm.chartData,"options":_vm.chartOptions}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }